import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { ShieldAlert } from "lucide-react";

export const Disclaimer = ({ t }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const show = () => setOpen(!localStorage.getItem("drnova_disclaimer"));
    window.addEventListener("drnova:splash-done", show);
    return () => window.removeEventListener("drnova:splash-done", show);
  }, []);
  const accept = () => { localStorage.setItem("drnova_disclaimer", "1"); setOpen(false); window.dispatchEvent(new Event("drnova:disclaimer")); };
  return (
    <Dialog open={open}>
      <DialogContent aria-describedby={undefined} data-testid="disclaimer-modal" className="border-slate-200 bg-white text-slate-800 [&>button]:hidden">
        <ShieldAlert className="text-orange-600" size={30} />
        <DialogTitle className="font-display text-2xl">{t("disclaimerTitle")}</DialogTitle>
        <p className="text-slate-600 leading-relaxed">{t("disclaimer")}</p>
        <div><button data-testid="disclaimer-accept-btn" onClick={accept} className="btn-primary w-full">{t("accept")}</button></div>
      </DialogContent>
    </Dialog>
  );
};
